export default __webpack_public_path__ + "static/media/globe-new.7e629006.jpeg";